export const HABILITATIONS = ["DPO", "DG", "CTO", "RSSI", "Juriste", "DAF", "RH", "Auditeur", "Autre"];

export const habColor = {
  DPO: { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
  DG: { bg: "#fdf4ff", text: "#7e22ce", border: "#e9d5ff" },
  CTO: { bg: "#ecfeff", text: "#0e7490", border: "#a5f3fc" },
  RSSI: { bg: "#fff7ed", text: "#c2410c", border: "#fed7aa" },
  Juriste: { bg: "#f0fdf4", text: "#15803d", border: "#bbf7d0" },
  DAF: { bg: "#fefce8", text: "#a16207", border: "#fef08a" },
  RH: { bg: "#fdf2f8", text: "#9d174d", border: "#f9a8d4" },
  Auditeur: { bg: "#f8fafc", text: "#334155", border: "#cbd5e1" },
  Autre: { bg: "#f9fafb", text: "#374151", border: "#e5e7eb" },
};

export function HabBadge({ habilitation }) {
  const c = habColor[habilitation] || habColor.Autre;
  return (
    <span style={{ display: "inline-block", padding: "2px 9px", borderRadius: 99, fontSize: 11, fontWeight: 700, background: c.bg, color: c.text, border: `1.5px solid ${c.border}` }}>
      {habilitation}
    </span>
  );
}
